import * as React from "react";
function MdIcon() {
    return React.createElement("path", { d: "M8.22915 13.774L5.01282 10.5368L5.75801 9.79167L8.22915 12.242L14.242 6.25L14.9872 7.016L8.22915 13.774Z", fill: "currentColor" });
}
export default MdIcon;
//# sourceMappingURL=Md.js.map